import { render } from "./SubirView.vue?vue&type=template&id=247f69bd"
import script from "./SubirView.vue?vue&type=script&lang=js"
export * from "./SubirView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__